import { venueConfig, VENUE_ONLY_IDS } from '@beat-venues/common-types';
import { Container, Logo, Text } from '../../';
import { VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import type { CommonProps } from '../../types';
import { useTranslation } from 'react-i18next';

import type { JSX } from 'react';

export interface VenueLogoListProps
    extends CommonProps,
        VariantProps<typeof VenueLogoListStyles> {
    title?: string;
    includeBeat?: boolean;
}

export const VenueLogoListStyles = cva(
    'flex flex-wrap xl:flex-nowrap justify-around gap-x-1 gap-y-6'
);

export const VenueLogoList = ({
    className,
    title,
    includeBeat,
    testId = 'venue-logo-list',
}: VenueLogoListProps): JSX.Element => {
    const { i18n } = useTranslation();
    const filteredVenue = ['sportpaleis'];

    if (!includeBeat) {
        filteredVenue.push('beat');
    }

    return (
        <Container data-testid={testId} className="mb-8 mt-12">
            <div className="mb-4 text-center">
                <Text size="lg">{title}</Text>
            </div>
            <div className={twMerge(VenueLogoListStyles({ className }))}>
                {VENUE_ONLY_IDS.filter(
                    (venue) => !filteredVenue?.includes(venue)
                ).map((id) => {
                    return (
                        <div
                            key={venueConfig(id).id}
                            className={`block w-48 pl-4 text-left lg:ml-4 lg:w-auto lg:pl-0 ${
                                venueConfig(id).id === 'beat' &&
                                'pr-2 lg:ml-0 xl:first:border-r-2'
                            } `}
                        >
                            <Logo
                                className="h-11 text-left lg:w-auto"
                                href={`${venueConfig(id, 'vite').url}${
                                    i18n.language || 'nl'
                                }`}
                                isInternalLink={false}
                                venueId={venueConfig(id).id}
                            />
                        </div>
                    );
                })}
            </div>
        </Container>
    );
};
